export default __webpack_public_path__ + "static/media/frg--outdoor-cinema.de4d1cf8.png";